import * as Types from '../generated/webapp_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateQuarterlyReportMutationVariables = Types.Exact<{
  input: Types.CreateQuarterlyReportInput;
}>;


export type CreateQuarterlyReportMutation = { __typename?: 'Mutation', createQuarterlyReport?: { __typename?: 'QuarterlyReport', id: string, summary: string, notes?: string | null, status?: Types.QuarterlyReportStatus | null, realizationDate: any, createdAt: any, receiverId?: number | null, goalsCollection?: { __typename?: 'GoalCollection', items: Array<{ __typename?: 'Goal', id: string, content?: string | null, goalStatus?: Types.GoalStatus | null } | null> } | null } | null };


export const CreateQuarterlyReportDocument = gql`
    mutation CreateQuarterlyReport($input: CreateQuarterlyReportInput!) {
  createQuarterlyReport(input: $input) {
    id
    summary
    notes
    status
    realizationDate
    goalsCollection {
      items {
        id
        content
        goalStatus
      }
    }
    createdAt
    receiverId
  }
}
    `;
export type CreateQuarterlyReportMutationFn = Apollo.MutationFunction<CreateQuarterlyReportMutation, CreateQuarterlyReportMutationVariables>;

/**
 * __useCreateQuarterlyReportMutation__
 *
 * To run a mutation, you first call `useCreateQuarterlyReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuarterlyReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuarterlyReportMutation, { data, loading, error }] = useCreateQuarterlyReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuarterlyReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuarterlyReportMutation, CreateQuarterlyReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuarterlyReportMutation, CreateQuarterlyReportMutationVariables>(CreateQuarterlyReportDocument, options);
      }
export type CreateQuarterlyReportMutationHookResult = ReturnType<typeof useCreateQuarterlyReportMutation>;
export type CreateQuarterlyReportMutationResult = Apollo.MutationResult<CreateQuarterlyReportMutation>;
export type CreateQuarterlyReportMutationOptions = Apollo.BaseMutationOptions<CreateQuarterlyReportMutation, CreateQuarterlyReportMutationVariables>;